import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Grid, Typography, Alert, Button } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  CustomSelect,
  CustomTextField,
  CustomDatePicker,
} from "../../../../shared/components/inputfields/form-elements";
import {
  EditableColumnDef,
  EditableTable,
} from "../../../../shared/components/table/inline-edit-table";
import {
  ITcCertifiedRawMaterialInformation,
  ITcCertifiedWeightInfo,
  ITcStandardCertifiedWeightInformation,
  reverseTransformToInputData,
  transformToRowData,
} from "../../tc-models/tc-req-dto/tc-certified-weight-info";
import { dtrackItService } from "../../tc-service/dtrackit.service";
import {
  FloatingButtonContainer,
  FloatingContainer,
  InnerButton,
} from "../../../../shared/components/buttons/floating-button-container";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../shared/components/loaders/page-loader";
import { useFormActions } from "../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../shared/hooks/useNotification";
import {
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../shared/app-configs/tc-app-configs";
import { Utills } from "../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import CustomTable from "../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../shared/components/table/custom-actions";
import { Pagination } from "../../../../shared/hooks/useRecordStore";
import RenderDetailPanel from "./standard-weight-render-details-panel";
import { isAdmin } from "../../../../shared/utils/admin-utils";
export interface RowData {
  tcStandard: string;
  tcCertifiedWeight: string;
  rawMaterialCode: string;
  rawMaterialCodeDesc: string;
  tcCertifiedRawMaterialCountryOrArea: string[];
  tcCertifiedRawMaterialStateOrProvince: string[];
}

interface StateOption {
  value: string;
  label: string;
}

let tcStandardCertifiedWeightInformationCount: ITcStandardCertifiedWeightInformation[] =
  [];

// Define Yup validation schema for each row, including the new "Roles" field

const initialData: RowData[] = [];
interface TcStandardWeightInfoProps {
  onNextTab: () => Promise<void>;
}

const TcStandardWeightInfo: React.FC<TcStandardWeightInfoProps> = ({
  onNextTab,
}) => {
  const [data, setData] = useState<RowData[]>(initialData);
  const [isNewRow, setIsNewRow] = useState(false);
  const [rawMaterialCode, setRawMaterialCode] = useState([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });

  const [country, setCountry] = useState<
    { value: string; label: string; code: string }[]
  >([]);
  const [payloadData, setPayLoadData] = useState<ITcCertifiedWeightInfo>();
  const navigate = useNavigate();
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const { loading, error, executeGet, setLoadingState, executePost } = useApi();
  const [getTCStdWeightInfo, setTCStdWeightInfo] = useState({
    OCS: 0,
    GRS: 0,
    RCS: 0,
    RDS: 0,
    RWS: 0,
    RMS: 0,
    RAS: 0,
    CCS: 0,
    SFA: 0,
    GOTS: 0,
  });
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [apiData, setAPIData] = useState<any>([]);
  const [selectedCountries, setSelectedCountries] = useState<any>([]);
  const { updateField, getCurrentFormValues, resetFormValueByPage } =
    useFormActions("certified-rawmaterials-std-details");
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [getTcStandardDetails, setTcStandardDetails] = useState<any>([]);
  const [getTcStandardCalc, setTcStandardCalc] = useState<any>([]);
  const [getAPITcStandard, setAPITcStandard] = useState<any>([]);
  const { getTCStandardGOTS, setStates, setCountryCodes } =
    useTransactionCertificateStore();
  const [stateDescriptionMap, setStateDescriptionMap] = useState<
    Record<string, string>
  >({});

  const tcStandardDetails = [
    {
      label: "Organic Content Standard (OCS)",
      value: "Organic Content Standard (OCS)",
      code: "OCS",
    }, // Represents "Valid"
    {
      label: "Global Recycled Standard (GRS)",
      value: "Global Recycled Standard (GRS)",
      code: "GRS",
    }, // Represents "Expired"
    {
      label: "Recycled Claim Standard (RCS)",
      value: "Recycled Claim Standard (RCS)",
      code: "RCS",
    }, // Represents "Suspended"
    {
      label: "Responsible Down Standard (RDS)",
      value: "Responsible Down Standard (RDS)",
      code: "RDS",
    }, // Represents "Withdrawn"
    {
      label: "Responsible Wool Standard (RWS)",
      value: "Responsible Wool Standard (RWS)",
      code: "RWS",
    }, // Represents "Withdrawn"
    {
      label: "Responsible Mohair Standard (RMS)",
      value: "Responsible Mohair Standard (RMS)",
      code: "RMS",
    }, // Represents "Withdrawn"
    {
      label: "Responsible Alpaca Standard (RAS)",
      value: "Responsible Alpaca Standard (RAS)",
      code: "RAS",
    }, // Represents "Withdrawn"
    {
      label: "Content Claim Standard (CCS)",
      value: "Content Claim Standard (CCS)",
      code: "CCS",
    }, // Represents "Withdrawn"
    {
      label: "Sustainable Fiber Alliance (SFA)",
      value: "Sustainable Fiber Alliance (SFA)",
      code: "SFA",
    }, // Represents "Withdrawn"
    {
      label: "Global Organic Textile Standard (GOTS)",
      value: "Global Organic Textile Standard (GOTS)",
      code: "GOTS",
    }, // Represents "Withdrawn"
  ];
  console.log("getTCStdWeightInfo", getTCStdWeightInfo);

  const standards = [
    {
      name: "Organic Content Standard (OCS)",
      value: getTCStdWeightInfo.OCS,
      key: "OCS",
    },
    {
      name: "Global Recycled Standard (GRS)",
      value: getTCStdWeightInfo.GRS,
      key: "GRS",
    },
    {
      name: "Recycled Claim Standard (RCS)",
      value: getTCStdWeightInfo.RCS,
      key: "RCS",
    },
    {
      name: "Responsible Down Standard (RDS)",
      value: getTCStdWeightInfo.RDS,
      key: "RDS",
    },
    {
      name: "Responsible Wool Standard (RWS)",
      value: getTCStdWeightInfo.RWS,
      key: "RWS",
    },
    {
      name: "Responsible Mohair Standard (RMS)",
      value: getTCStdWeightInfo.RMS,
      key: "RMS",
    },
    {
      name: "Responsible Alpaca Standard (RAS)",
      value: getTCStdWeightInfo.RAS,
      key: "RAS",
    },
    {
      name: "Content Claim Standard (CCS)",
      value: getTCStdWeightInfo.CCS,
      key: "CCS",
    },
    {
      name: "Sustainable Fiber Alliance (SFA)",
      value: getTCStdWeightInfo.SFA,
      key: "SFA",
    },
    {
      name: "Global Organic Textile Standard (GOTS)",
      value: getTCStdWeightInfo.GOTS,
      key: "GOTS",
    },
  ];
  const fetchStandardDetails = async () => {
    let response: any = await executeGet(TCAppConfig.GET_TC_BASE_DETAILS, {
      tcId: TE_ID,
    });
    if (response?.data) {
      setAPITcStandard(response?.data?.tcStandard);
      const selectedRecords = tcStandardDetails.filter((item) =>
        response?.data?.tcStandard.includes(item.code)
      );
      const calcRecords = standards.filter((item) =>
        response?.data?.tcStandard.includes(item.key)
      );
      // //alert(selectedRecords)
      setTcStandardDetails(selectedRecords);
      setTcStandardCalc(calcRecords);
      console.log(`getTcStandardCalc ${JSON.stringify(getTcStandardCalc)}`);
    }
  };
  const fetchProductWeightDetails = async (mat_codes: any) => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_CERTIFIED_WEIGHT_INFO,
        {
          tcId: TE_ID,
        }
      );

      // Changes related to state descriptions
      // Create temporary state description map from response data
      const newStateMap = { ...stateDescriptionMap };

      // Extract state codes and descriptions from the response
      if (response?.data?.tcDetails?.tcStandardCertifiedWeightInformation) {
        response.data.tcDetails.tcStandardCertifiedWeightInformation.forEach(
          (standard: any) => {
            standard.tcCertifiedRawMaterialInformation.forEach(
              (material: any) => {
                // Check if both arrays exist and have matching lengths
                if (
                  Array.isArray(
                    material.tcCertifiedRawMaterialStateOrProvince
                  ) &&
                  Array.isArray(
                    material.tcCertifiedRawMaterialStateOrProvinceDescription
                  ) &&
                  material.tcCertifiedRawMaterialStateOrProvince.length ===
                    material.tcCertifiedRawMaterialStateOrProvinceDescription
                      .length
                ) {
                  // Map each state code to its description
                  material.tcCertifiedRawMaterialStateOrProvince.forEach(
                    (stateCode: string, index: number) => {
                      // Only add if not already in the map and description is not empty
                      if (
                        !newStateMap[stateCode] &&
                        material
                          .tcCertifiedRawMaterialStateOrProvinceDescription[
                          index
                        ]
                      ) {
                        newStateMap[stateCode] =
                          material.tcCertifiedRawMaterialStateOrProvinceDescription[
                            index
                          ];
                      }
                    }
                  );
                }
              }
            );
          }
        );
      }

      // Update the state description map
      setStateDescriptionMap(newStateMap);

      let responseConsolidated: any = [];
      try {
        responseConsolidated = await executeGet(
          TCAppConfig.GET_CERTIFIED_WEIGHT_INFO_CONSOLIDATED,
          {
            tcId: TE_ID,
            limit: pagination?.pageSize,
            offset: pagination?.pageIndex * pagination?.pageSize,
          }
        );
      } catch (error) {
        responseConsolidated = [];
        console.error("Error fetching consolidated weight info:", error);
      }
      setRowCount(responseConsolidated?.data?.no_of_records);

      let data = transformToRowData(response?.data, responseConsolidated?.data?.response);
      console.log("Transformed Data:", data);

      data = data.map((dat: any) => {
        let rawMatCode =
          (mat_codes as { value: string; label: string }[]).find(
            (code) => code.value === dat.tcCertifiedRawMaterialCode
          )?.label || "";
        let tcStandardDesc =
          tcStandardDetails.find((dat1: any) => dat1.code === dat.tcStandard)
            ?.label || "";
        return {
          ...dat,
          rawMaterialCodeDesc: rawMatCode,
          tcStandardDesc: tcStandardDesc,
        };
      });
      console.log("Mapped Data:", data);

      setData(data);
      setAPIData(data);

      data.length > 0 ? setNextEnabled(true) : setNextEnabled(false);
      // }
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const setZustandInitialState = (initialState?: any) => {
    const defalutState: any = {
      "std-weight-info": [
        {
          tcStandard: "",
          tcCertifiedWeight: "",
          rawMaterialCode: "",
          rawMaterialCodeDesc: "",
          country: [],
          state: [],
          tcProductRawMaterialOrder: 0,
        },
      ],
    };
    //set zustand state inital values
    Object.entries(initialState ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  const mapPayLoad = (data: any[]): ITcStandardCertifiedWeightInformation[] => {
    const tcStandardCertifiedWeightInformationData: ITcStandardCertifiedWeightInformation[] =
      [];

    data.forEach((row) => {
      const existingEntry = tcStandardCertifiedWeightInformationData.find(
        (entry) => entry.tcStandard === row.tcStandard
      );

      const rawMaterialInfo: ITcCertifiedRawMaterialInformation = {
        tcCertifiedRawMaterialCode:
          row.rawMaterialCode || row.tcCertifiedRawMaterialCode,
        tcCertifiedRawMaterialWeight: parseFloat(row.tcCertifiedWeight),
        tcGeographicWeightInfo: row.tcGeographicWeightInfo,
        // tcCertifiedRawMaterialCountryOrArea: row.country,
        // tcCertifiedRawMaterialCountryOrAreaDescription: row.tcCertifiedRawMaterialCountryOrAreaDescription,
        // tcCertifiedRawMaterialStateOrProvince: row.state,
        // tcCertifiedRawMaterialStateOrProvinceDescription: row.tcCertifiedRawMaterialStateOrProvinceDescription
      };

      if (existingEntry) {
        //(`existingEntry.tcCertifiedWeight ${existingEntry.tcCertifiedWeight}`)
        existingEntry.tcCertifiedWeight += parseFloat(row.tcCertifiedWeight);
        existingEntry.tcCertifiedRawMaterialInformation.push(rawMaterialInfo);
      } else {
        //(`newentry.tcCertifiedWeight ${row.tcCertifiedWeight}`)
        // Create a new entry
        tcStandardCertifiedWeightInformationData.push({
          tcStandard: row.tcStandard,
          tcCertifiedWeight: parseFloat(row.tcCertifiedWeight),
          tcCertifiedRawMaterialInformation: [rawMaterialInfo],
        });
      }
    });

    return tcStandardCertifiedWeightInformationData;
  };
  const sumWeight = (data: any[], standard: string) => {
    //('Filtering for standard: ', standard); // Debug log for standard
    const weightSum = data
      .filter((m) => m.tcStandard.toLowerCase() === standard.toLowerCase()) // Filter by tcStandard
      .reduce((sum, current) => {
        const rowWeightSum = current.tcCertifiedRawMaterialInformation.reduce(
          (rowSum: any, rawMaterial: any) =>
            rowSum +
            (isNaN(rawMaterial.tcCertifiedRawMaterialWeight)
              ? 0
              : rawMaterial.tcCertifiedRawMaterialWeight),
          0
        );

        return sum + rowWeightSum;
      }, 0);

    //(`Total weight for ${standard}: `, weightSum); // Debug log for total weight
    // Round to 2 decimal places
    return parseFloat(weightSum.toFixed(2));
  };

  const validationSchema = Yup.object().shape({
    tcStandard: Yup.string().when([], {
      is: () => !getTCStandardGOTS, // If GOTS is NOT included, apply required validation
      then: Yup.string().required("TC Standard is required"),
      otherwise: Yup.string().nullable(), // Skip required validation
    }),

    tcCertifiedWeight: Yup.string().required("Raw Material Weight is required"),

    rawMaterialCode: Yup.string().required("Raw Material Code is required"), // Dropdown selection must have a value

    country: Yup.array()
      .of(Yup.string()) // Array of strings (country codes)
      .min(1, "At least one country must be selected") // Must select at least one option
      .required("Country is required"), // Field is required

    state: Yup.array()
      .of(Yup.string())
      .test(
        "state-required-for-country",
        "At least one state must be selected for each selected country",
        function (states: any) {
          const { country } = this.parent;

          if (!Array.isArray(country) || country.length === 0) {
            return true;
          }

          const isMatch = country.every((c: any) =>
            states.some((stat: any) => stat.startsWith(c))
          );

          if (!isMatch) {
            return this.createError({
              message:
                "Atleast one State is required for the selected countries",
            });
          }
          return Array.isArray(states) && states.length > 0; // Validate states
        }
      )
      .required("State is required"), // Field is required
  });
  const calculateTCStdSummaryWeight = (data: any) => {
    const getWeightInfo: any = mapPayLoad(data);
    setTCStdWeightInfo({
      CCS: sumWeight(getWeightInfo, "ccs"),
      GRS: sumWeight(getWeightInfo, "grs"),
      OCS: sumWeight(getWeightInfo, "ocs"),
      RAS: sumWeight(getWeightInfo, "ras"),
      RCS: sumWeight(getWeightInfo, "rcs"),
      RDS: sumWeight(getWeightInfo, "rds"),
      RMS: sumWeight(getWeightInfo, "rms"),
      RWS: sumWeight(getWeightInfo, "rws"),
      SFA: sumWeight(getWeightInfo, "sfa"),
      GOTS: sumWeight(getWeightInfo, "gots"),
    });
  };
  useMemo(() => calculateTCStdSummaryWeight(data), [data]);

  useEffect(() => {
    const getStdWeightInfo = getCurrentFormValues();
    if (getStdWeightInfo["std-weight-info"]) {
      setData(getStdWeightInfo["std-weight-info"]);
      calculateTCStdSummaryWeight(getStdWeightInfo["std-weight-info"]);
      setZustandInitialState(getStdWeightInfo["std-weight-info"]);
    } else {
      setZustandInitialState(null);
    }
    if (apiData.length <= 0) {
      resetFormValueByPage();
    }
    const getRawMaterialCode = async () => {
      try {
        const result: any = await dtrackItService.getRawMaterialCodes();
        //(`materiaCodes result ${JSON.stringify(result)}`)

        const materiaCodes = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        //(`materiaCodes ${materiaCodes}`)
        setRawMaterialCode(materiaCodes);
        return materiaCodes;
      } catch (err) {
        //(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };

    const getCountry = async () => {
      try {
        const result: any = await dtrackItService.getCountry();
        //(`getCountry result ${JSON.stringify(result)}`)

        const countries = result.data.map((t: any) => ({
          value: `${t.description_1} (${t.code_1})`,
          label: `${t.description_1} (${t.code_1})`,
          code: t.code_1,
        }));
        //(`countries ${countries}`)
        setCountry(countries);
        setCountryCodes(countries);
        //(`getCountry ${country}`)
      } catch (err) {
        //(`Error in Fetching Organic Farm Standard Code ${err}`)
      }
    };
    async function fetchDetails() {
      let mat_codes = await getRawMaterialCode();
      if (TE_ID) {
        await fetchProductWeightDetails(mat_codes);

        await fetchStandardDetails();
      }

      await getCountry();
    }
    fetchDetails();
  }, [pagination?.pageIndex]);

  useEffect(() => {
    if (data.length > 0) {
      data.forEach((item: any, index) => {
        item.tcProductRawMaterialOrder = index + 1;
      });
      updateField("std-weight-info", data);
    }
  }, [data]);
  const formRef = useRef(null);
  const { notify } = useNotification();

  const formik = useFormik<RowData>({
    initialValues: {
      tcStandard: "", // Selected option in "TC Standard" dropdown
      tcCertifiedWeight: "", // Text value for "RM Certified Weight"
      rawMaterialCode: "", // Selected option in "Raw Material Code" dropdown
      rawMaterialCodeDesc: "",
      tcCertifiedRawMaterialCountryOrArea: [], // Multi-select options for "Country"
      tcCertifiedRawMaterialStateOrProvince: [], // Multi-select options for "State"
    },
    validationSchema,
    innerRef: formRef,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      setData((prevData) => [...prevData, values]);
      // setEditingRowIndex(-1);
      setIsNewRow(false);
      formik.resetForm();
    },
  });

  const handleSaveInnerRow = (rowData: any) => {};

  const onNext = () => {
    const checkGeographicWeightMatchestcCertifiedWeight = data.every(
      (item: any) => {
        let totalGeographicWeight = 0;
        item.tcGeographicWeightInfo.forEach((geoWeight: any) => {
          totalGeographicWeight += parseFloat(geoWeight.tcGeographicWeight);
        });
        // Round both values to 2 decimal places to avoid floating-point precision issues
        const roundedGeoWeight = parseFloat(totalGeographicWeight.toFixed(2));
        const roundedCertifiedWeight = parseFloat(parseFloat(item.tcCertifiedWeight).toFixed(2));
        return roundedGeoWeight === roundedCertifiedWeight;
      }
    );

    if (!checkGeographicWeightMatchestcCertifiedWeight) {
      notify(
        "Please ensure that the sum of geographic weights matches the certified weight for each standard",
        "error"
      );
      return;
    }
    navigate(`/tc/${formtype}/Input-tc-product-details/${TE_ID}`);
  };

  const saveData = async () => {
    const checkGeographicWeightMatchestcCertifiedWeight = data.every(
      (item: any) => {
        let totalGeographicWeight = 0;
        item.tcGeographicWeightInfo.forEach((geoWeight: any) => {
          totalGeographicWeight += parseFloat(geoWeight.tcGeographicWeight);
        });
        // Round both values to 2 decimal places to avoid floating-point precision issues
        const roundedGeoWeight = parseFloat(totalGeographicWeight.toFixed(2));
        const roundedCertifiedWeight = parseFloat(parseFloat(item.tcCertifiedWeight).toFixed(2));
        return roundedGeoWeight === roundedCertifiedWeight;
      }
    );

    if (!checkGeographicWeightMatchestcCertifiedWeight) {
      notify(
        "Please ensure that the sum of geographic weights matches the certified weight for each standard",
        "error"
      );
      return;
    }
    setLoadingState(true);
    // navigate('/create-tc/Input-tc-product-details')
    // ToDo commented for demo
    console.log("payloadData :", payloadData);
    console.log("data :", data);

    const mapToPayload = reverseTransformToInputData(data, TE_ID);
    console.log("payload :", mapToPayload);

    const result: any = await executePost(
      TCAppConfig.TC_STD_WEIGHT_INFO_ENDPOINT,
      mapToPayload
    );
    // await transactionCertificateService.saveTCStdWeightInfo(payloadData)
    if (result.status == 200) {
      // const navigate = useNavigate();
      await onNextTab();
      notify("Saved Succesfully", "success");
      navigate(`/tc/${formtype}/Input-tc-product-details/${TE_ID}`);
    } else {
      setLoadingState(false);
      notify("Unable to Save", "error");
    }
  };

  // Define columns inside the component to access formik
  const columns: EditableColumnDef<RowData>[] = [
    {
      accessorKey: "tcStandardDesc",
      header: "Standard",
      Header: (
        <span>
          {" "}
          {!getTCStandardGOTS ? <i style={{ color: "red" }}>* </i> : <></>}
          Standard
        </span>
      ),
    },
    {
      accessorKey: "rawMaterialCodeDesc",
      header: "Certified Raw Material Code",
      Header: (
        <span>
          {" "}
          <i style={{ color: "red" }}>* </i> Certified Raw Material Code
        </span>
      ),
    },
    {
      accessorKey: "tcCertifiedWeight",
      header: "Certified Raw Material Weight",
      Header: (
        <span>
          {" "}
          <i style={{ color: "red" }}>* </i> Certified Raw Material Weight
        </span>
      ),
    },
    // {
    //   accessorKey: "tcCertifiedRawMaterialCountryOrAreaDescription",
    //   header: "Country/Area",
    //   Header: <span>  <i style={{ color: 'red' }}>* </i> Country/Area</span>,
    //   renderEditCell: ({ value, onChange }) => (
    //     <CustomSelect
    //       label=""
    //       value={value}
    //       options={country}
    //       enableSearch={true}
    //       onChange={(e, index) => {
    //         console.log("e.target country :: ", e.target.value);

    //         //(` CustomSelect${e.target.value}`)
    //         setSelectedCountries(e.target.value)
    //         // getState(e.target.value)
    //         onChange(e.target.value)
    //         handleCountryChange(e.target.value, index)
    //       }}
    //       multiple // Enable multi-select
    //       placeholder="Select Country/Area"
    //     />
    //   ),
    // },
    // {
    //   accessorKey: "tcCertifiedRawMaterialCountryOrAreaDescription",
    //   header: "Country/Area Description",
    //   Header: <span>  <i style={{ color: 'red' }}>* </i> Country/Area Description</span>,
    // },
    // {
    //   accessorKey: "stateDesc",
    //   header: "State/Province",
    //   Header: <span> <i style={{ color: 'red' }}>* </i>State/Province</span>,
    //   renderEditCell: ({ value, onChange }) => (
    //     <CustomSelect
    //       label=""
    //       value={value}
    //       options={state}
    //       enableSearch={true}
    //       onChange={(e, index) => {
    //         console.log("This function is called")
    //         // Get the selected state values
    //         const selectedStates = e.target.value;

    //         // Only proceed if we have selections and they're in an array
    //         if (Array.isArray(selectedStates) && selectedStates.length > 0) {
    //           // Create a new map to avoid direct state mutation
    //           const newStateMap = { ...stateDescriptionMap };
    //           let mapUpdated = false;

    //           // For each selected state, check if it's already in the map
    //           selectedStates.forEach((stateCode) => {
    //             // Only add to map if it doesn't already exist
    //             if (!stateDescriptionMap[stateCode]) {
    //               const stateOption = state.find((option: any) => option.value === stateCode);
    //               if (stateOption) {
    //                 newStateMap[stateCode] = stateOption.label;
    //                 mapUpdated = true;
    //               }
    //             }
    //           });
    //           console.log("newStateMap------->", newStateMap)
    //           // Only update the state map if something changed
    //           if (mapUpdated) {
    //             setStateDescriptionMap(newStateMap);
    //             console.log("Updated state description map:", newStateMap);
    //           }
    //         }

    //         // Call the original onChange handler
    //         onChange(e.target.value);
    //       }}
    //       multiple // Enable multi-select
    //       placeholder="Select State/Province"
    //     />
    //   ),
    // },
    // {
    //   accessorKey: "stateDesc",
    //   header: "State/Province Description",
    //   Header: <span>  <i style={{ color: 'red' }}>* </i> State/Province Descriptiont</span>,
    // }
  ];

  const customeEmptyRecordComponent = (
    <div
      style={{
        margin: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "400",
        fontFamily: "Roboto, Arial, sans-serif",
        fontSize: "1rem",
        lineHeight: "1.5",
        color: "rgb(76, 76, 76) !important",
        fontStyle: "italic",
      }}
    >
      <div>
        <Typography style={{ color: "rgb(76, 76, 76) !important" }}>
          No records found for the selected criteria.
        </Typography>
        <Typography style={{ color: "rgb(76, 76, 76) !important" }}>
          Please ensure that:
        </Typography>
        <ul>
          <li>
            The correct raw material code is selected for the chosen standard.
          </li>
          <li>
            Or consider changing the Product Raw Material as per selected
            standard.
          </li>
        </ul>
        <Button
          style={{ fontSize: "1rem", marginRight: "35px" }}
          onClick={() => {
            navigate(`/tc/${formtype}/certified-products-components/${TE_ID}`);
          }}
        >
          Return to Certified Products Tab
        </Button>
      </div>
    </div>
  );

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <div>
          <Typography fontWeight={"600"}>
            Summary of TC Standard Certified Weight
          </Typography>
          {getAPITcStandard.length > 0 ? (
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 1,
                border: "2px solid rgba(128, 128, 128, .2)",
                my: 4,
              }}
            >
              <Grid container spacing={2}>
                {standards
                  .filter((item) => getAPITcStandard.includes(item.key))
                  .map((standard: any, index: any) => (
                    <Grid item xs={12} sm={4} key={index}>
                      <Typography>
                        <span>
                          {" "}
                          {getTCStandardGOTS ? (
                            <i style={{ color: "red" }}>* </i>
                          ) : (
                            <></>
                          )}
                        </span>{" "}
                        {standard.name} : {typeof standard.value === 'number' ? standard.value.toFixed(2) : standard.value}{" "}
                        <span>
                          {" "}
                          {getTCStandardGOTS ? (
                            <Alert severity="error">
                              Please Add a record to Calculate TC Certified
                              Weight .
                            </Alert>
                          ) : (
                            <></>
                          )}
                        </span>
                      </Typography>
                      {/* {getTCStandardGOTS ? <Alert severity="error">Please Add a record to Calculate TC Certified Weight .</Alert> : <></>} */}
                    </Grid>
                  ))}
              </Grid>
            </Box>
          ) : (
            <> </>
          )}
          <Typography margin={"10px"} fontWeight={"400"} fontStyle={"italic"}>
            Please expand the table to enter Country/Area, State/Province level
            certified weight
          </Typography>
          <Box sx={{ width: "100%", textAlign: "left", mb: 3 }} display="grid">
            {/* <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitTC && <StyledButton
              onClick={handleAddNewRow}
              disabled={!formik.isValid}
              sx={{ mb: 2 }}
            >
              Add Certified Raw Material
            </StyledButton>}
          </Box> */}
            {/* <EditableTable
            data={data}
            columns={columns}
            onSaveRow={handleSaveRow}
            onCellChange={handleCellChange}
            editingRowIndex={editingRowIndex}
            onCancelEdit={handleCancelEdit}
            onEditRow={handleEditRow}
            onDeleteRow={()=>{}}
            hideDelete={true}
            enableEditing={!hasSubmitTC}
            customeEmptyRecordText={true}
            customeEmptyRecordComponent={customeEmptyRecordComponent}
            formtype={formtype}
            TE_ID={TE_ID}
          /> */}
            <CustomTable
              columns={columns}
              data={data}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              paginations={pagination}
              setPaginations={setPagination}
              rowCount={rowCount}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel
                    data={data}
                    hasSubmitTC={hasSubmitTC}
                    row={row}
                    TE_ID={TE_ID}
                    formtype={formtype}
                    country={country}
                    stateDescriptionMap={stateDescriptionMap}
                    setStateDescriptionMap={setStateDescriptionMap}
                    mapPayLoad={mapPayLoad}
                    setPayLoadData={setPayLoadData}
                    setNextEnabled={setNextEnabled}
                  />
                ) : (
                  <>NO data</>
                )
              }
              // renderRowActions={({ row }) => (
              //   <ActionsMenu row={row} onEdit={handleEditRow} onDelete={()=>{}} />
              // )}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: "0.5rem",
            }}
          >
            <NavLink to="/tc-dashboard">
              <InnerButton>Home</InnerButton>
            </NavLink>
            {(data.length > 0 || apiData.length > 0) && (
              <>
                {!isNextEnabled && !isAdmin() && (
                  <InnerButton onClick={saveData}>Save & Next</InnerButton>
                )}
                {(isNextEnabled || isAdmin()) && (
                  <InnerButton onClick={onNext}>Next</InnerButton>
                )}
              </>
            )}
            {hasSubmitTC && (
              <>
                <NavLink
                  to={`/tc/${formtype}/certified-products-components/${TE_ID}`}
                >
                  <InnerButton>Back</InnerButton>
                </NavLink>
                <InnerButton onClick={onNext}>Next</InnerButton>
              </>
            )}
          </Box>
        </div>
      )}
    </>
  );
};
export default TcStandardWeightInfo;
